import { z } from "zod";

export const searchBarSchema = z.object({ query: z.string() });

export type SearchBarFormData = z.infer<typeof searchBarSchema>;
